export const enum AUDIENCE {
  personal = 'personal',
  work = 'work',
  school = 'school',
}
